export const foundEnergized = (map, e) => {

	map.addSource("nrgzd", { type: "geojson", data: e.findenergized });
	map.addLayer({
		id: "NRGZD:LINE-PHASE-A",
		type: "line",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["in", "A", ["get", "phase"]], ["has", "feederid"]],
		layout: { "visibility": "visible", "line-cap": "round" },
		paint: { "line-width": 1.75, "line-color": "#982013", "line-offset": -2.25 }
	});

	// Phase B Line
	map.addLayer({
		id: "NRGZD:LINE-PHASE-B",
		type: "line",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["in", "B", ["get", "phase"]], ["has", "feederid"]],
		layout: { "visibility": "visible", "line-cap": "round" },
		paint: { "line-width": 1.75, "line-color": "#19950c", "line-offset": 0 }
	});

	// Phase C Line
	map.addLayer({
		id: "NRGZD:LINE-PHASE-C",
		type: "line",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["in", "C", ["get", "phase"]], ["has", "feederid"]],
		layout: { "visibility": "visible", "line-cap": "round" },
		paint: { "line-width": 1.75, "line-color": "#18338b", "line-offset": 2.25 }
	});

	// Load
	map.addLayer({
		id: "NRGZD:LOAD",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "LOAD"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XTRA|LOAD|001",
			"icon-size": 1.25,
			"icon-allow-overlap": true,
			"visibility": "visible"
		},
		paint: {}
	});

	// Devices ABC
	map.addLayer({
		id: "NRGZD:DEVICES-ABC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "ABC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|ABC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices AB
	map.addLayer({
		id: "NRGZD:DEVICES-AB",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "AB"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|AB",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices BC
	map.addLayer({
		id: "NRGZD:DEVICES-BC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "BC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|BC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices AC
	map.addLayer({
		id: "NRGZD:DEVICES-AC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "AC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|AC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices A
	map.addLayer({
		id: "NRGZD:DEVICES-A",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "A"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|A",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices B
	map.addLayer({
		id: "NRGZD:DEVICES-B",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "B"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|B",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Devices C
	map.addLayer({
		id: "NRGZD:DEVICES-C",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "DEVICE"], ["==", "phase", "C"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|DVCE|003|C",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers ABC
	map.addLayer({
		id: "NRGZD:Transformers-ABC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "ABC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|ABC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers AB
	map.addLayer({
		id: "NRGZD:Transformers-AB",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "AB"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|AB",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers AC
	map.addLayer({
		id: "NRGZD:Transformers-AC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "AC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|AC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers BC
	map.addLayer({
		id: "NRGZD:Transformers-BC",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "BC"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|BC",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers A
	map.addLayer({
		id: "NRGZD:Transformers-A",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "A"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|A",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers B
	map.addLayer({
		id: "NRGZD:Transformers-B",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "B"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|B",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	// Transformers C
	map.addLayer({
		id: "NRGZD:Transformers-C",
		type: "symbol",
		source: "nrgzd",
		/*no source layer for geojson*/
		filter: ["all", ["==", "status", "TRANSFORMER"], ["==", "phase", "C"]],
		layout: {
			"icon-image": "SPRITES.LVWR.IO:LVWR|XFMR|004|C",
			"icon-allow-overlap": true,
			"visibility": "visible",
			"icon-size": 1.25
		},
		paint: {}
	});

	map.addLayer({
		id: "NRGZD:DEVICES-SOURCE",
		type: "symbol",
		source: "nrgzd",
		filter: ["all", ["==", "status", "SOURCE"]],
		layout: {
			"icon-size": 1.25,
			"icon-image": "SPRITES.LVWR.IO:LVWR|XTRA|SRCE",
			"icon-allow-overlap": true,
			"visibility": "visible"
		},
		paint: {}
	})

	// Animated Flow Direction Arrow
	map.addLayer({
		id: "NRGZD:Flow-Direction",
		type: "symbol",
		source: "nrgzd",
		//ifilter: ["all", ["has", "feederid"], ["!has", "issues"]],
		layout: {
			"text-field": " → ",
			"symbol-placement": "line",
			"text-ignore-placement": false,
			"text-keep-upright": false,
			"text-size": 25,
			"text-offset": [0, 0.5],
			"text-allow-overlap": false,
			"symbol-spacing": 50,
			"visibility": "visible"
		},
		paint: { "text-color": "orange" },
	});

	// Add animation
	// let animationPhase = 0;
	// const animationDuration = 2000; // ms for a complete cycle
	// let lastFrameTime = 0;
	//
	// // Arrow function for animation
	// const animateFlowArrows = (timestamp) => {
	// 	if (!lastFrameTime) lastFrameTime = timestamp;
	// 	const deltaTime = timestamp - lastFrameTime;
	// 	lastFrameTime = timestamp;
	//
	// 	// Update animation phase - continuously increasing
	// 	animationPhase = (animationPhase + deltaTime / animationDuration) % 1;
	//
	// 	// This creates the illusion of forward movement along the line
	// 	// By changing symbol-spacing property
	// 	map.setLayoutProperty("NRGZD:Flow-Direction", "symbol-spacing",
	// 		10 + animationPhase * 10); // Ranges from 200 to 0 and loops
	//
	// 	// Request the next frame
	// 	requestAnimationFrame(animateFlowArrows);
	// };
	// // Start the animation
	// requestAnimationFrame(animateFlowArrows);




}



export const removeSourceAndLayers = (map, sourceId) => {
	// Get all layers in the map
	const layers = map.getStyle().layers;

	// Find and remove all layers that use the specified source
	for (const layer of layers) {
		if (layer.source === sourceId) {
			// Remove this layer from the map
			map.removeLayer(layer.id);
			console.log(`Removed layer: ${layer.id}`);
		}
	}

	// Check if the source exists before trying to remove it
	if (map.getSource(sourceId)) {
		// Remove the source
		map.removeSource(sourceId);
		console.log(`Removed source: ${sourceId}`);
	} else {
		console.warn(`Source ${sourceId} not found`);
	}
}
